// extracted by mini-css-extract-plugin
export var card = "_8a-0";
export var failedIcon = "_8a-4";
export var failedIconBadge = "_8a-3";
export var icon = "_8a-1";
export var successIcon = "_8a-2";